<div class="modal-container">
    <div class="modal-header mb-5">
        <h2 class="modal-title">
            <span>{{globalConstants.ON_BOARDING_MODAL_HEADER_LABEL}}</span>
        </h2>
        <button type="button" class="close btn-close" (mousedown)="onClose()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="need-access-form-container">
            <div class="detail-tab-content-container">
                <div class="row mb-5">
                    <div class="col-sm-12 pe-5p sm-ps-6">
                        <form [formGroup]="personalDataForm" autocomplete="one-time-code">
                            <div class="form-elements-container">
                                <div class="form-elements-wrap">
                                    <div class="form-element-col">
                                        <div class="form-input-wrap">
                                            <label
                                                class="form-label form-label-custom">{{globalConstants.FIRST_NAME_NEW_REQUEST}}<span
                                                    class="required-text">*</span></label>
                                            <input type="text" class="form-control form-control-custom"
                                                placeholder="Enter name" formControlName="firstName" appTrim charsOnly>
                                        </div>
                                    </div>
                                    <div class="form-element-col">
                                        <div class="form-input-wrap">
                                            <label
                                                class="form-label form-label-custom">{{globalConstants.LAST_NAME_NEW_REQUEST}}<span
                                                    class="required-text">*</span></label>
                                            <input type="text" class="form-control form-control-custom"
                                                placeholder="Enter lastname" formControlName="lastName" charsOnly
                                                appTrim>
                                        </div>
                                    </div>
                                    <div class="form-element-col">
                                        <div class="form-input-wrap">
                                            <label for="birthDate"
                                                class="form-label form-label-custom">{{globalConstants.HIRING_DATE}}<span
                                                    class="required-text">*</span></label>
                                            <div class="datepicker-input-wrap">
                                                <input type="text" class="form-control form-control-custom"
                                                    id="hiringDate" formControlName="hiringDate" placeholder="Select"
                                                    #hd="bsDatepicker" bsDatepicker [bsConfig]="hiringDatePickerConfig"
                                                    placeholder="MM/DD/YYYY" placement="bottom"
                                                    (change)="hiringDateEdit()">
                                                <img src="../../../../assets/img/icons/calendar.svg"
                                                    class="img-fluid calender-icon" (click)="hd.toggle()" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-element-btn-col">
                                        <div class="form-input-wrap buttonTop">
                                            <button type="button" class="btn btn-orange"
                                                [disabled]="!getBtnEnableStatus()"
                                                (click)="generateEntityID()">{{globalConstants.FETCH_AVAILABLE_ID}}</button>
                                        </div>
                                    </div>
                                    <div class="generatedID">
                                        <label class="generate-id-label">
                                            <span>{{newAllocatedID}}</span>
                                        </label>
                                        <img src="../../../../assets/img/icons/copy.svg" class="copy-icon ml-2"
                                            title="copy" [cdkCopyToClipboard]="newAllocatedID"
                                            (cdkCopyToClipboardCopied)="onClipboardCopy($event)"
                                            *ngIf="newAllocatedID" />
                                    </div>

                                </div>

                            </div>
                        </form>

                    </div>
                </div>

                <div class="row mt-5 mb-5">
                    <div class="col">
                        <div> {{globalConstants.ON_BOARDING_MODAL_HEADER_ALLOCATED}}</div>
                        <weaccess-table [tableColumns]="allocatedTableColumns"
                            [tableData]="allocatedTableData"></weaccess-table>
                    </div>
                </div>
                <div class="row mt-5 mb-5">
                    <div class="col">
                        <div>{{globalConstants.ON_BOARDING_MODAL_HEADER_CREATED}} </div>
                        <weaccess-table [tableColumns]="createdTableColumns"
                            [tableData]="createdTableData"></weaccess-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>